export default "__VITE_ASSET__BSWZW8v6__"